module.exports = __webpack_public_path__ + "img/log-out.18a23f38.svg";